import { App, TaasInfo } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { taasInfoReducer } from '@ps20-frontend/preis-lib';
import { IAppState } from '../appState';

export const tkvTaasInfoReducer = function (
  sectionState: TaasInfo = null,
  action: AnyAction,
  appState: IAppState,
): TaasInfo {
  return taasInfoReducer(sectionState, action, App.TKV_V2, appState?.angebotsId);
};
